import { createUserWithEmailAndPassword, fetchSignInMethodsForEmail } from "firebase/auth";
import { auth } from "../firebase/config";

const ADMIN_EMAIL = "admin@example.com";
const ADMIN_PASSWORD = "password123";

export const ensureDefaultAdminExists = async () => {
  try {
    const methods = await fetchSignInMethodsForEmail(auth, ADMIN_EMAIL);

    if (methods.length === 0) {
      await createUserWithEmailAndPassword(auth, ADMIN_EMAIL, ADMIN_PASSWORD);
      if (process.env.NODE_ENV === 'development') {
        console.log("✅ Default admin account created.");
      }
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.log("ℹ️ Admin account already exists.");
      }
    }
  } catch (error) {
    if (process.env.NODE_ENV === 'development') {
      console.error("❌ Error ensuring admin account:", error.message);
    } else {
      console.error("#1 Something went wrong!!");
    }
  }
};
